import {
    Grid,
    Typography,
    Paper,
} from '@material-ui/core';

const formContainerStyle = {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

const ContactForm = (props) => (
    <div>
        <Typography Typography variant="h3"  style={{ color: "#356D7F", fontWeight: 'bold' }} gutterBottom>
            {props.header}
        </Typography>
        <Typography variant="body1" paragraph>
            {props.body}
        </Typography>
        <Paper elevation={3} style={formContainerStyle}>
            <Grid container spacing={3}>
                <iframe src="https://forms.gle/9feVw8Tcc1bjzJ2H8?embedded=true" width="640" height="600" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </Grid>
        </Paper>
    </div>
);

export default ContactForm;